import { render, staticRenderFns } from "./simple-select.vue?vue&type=template&id=0337031b&scoped=true&"
import script from "./simple-select.vue?vue&type=script&lang=js&"
export * from "./simple-select.vue?vue&type=script&lang=js&"
import style0 from "./simple-select.vue?vue&type=style&index=0&id=0337031b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0337031b",
  null
  
)

export default component.exports